import { convertAmountToHkd } from "./arFormInvestmentAmountUtils";

export const resolveDeclaredNetWealthFromClientAssets = (client, rateMap = {}) => {
  if (!client || typeof client !== "object") return null;

  const currency = client.currentAssetsCurrency || "HKD";
  const { hkdAmount, missingRate } = convertAmountToHkd(
    client.currentAssets,
    currency,
    rateMap
  );

  if (missingRate || hkdAmount == null) return null;
  return hkdAmount;
};

export const shouldPrefillDeclaredNetWealth = (declaredNetWealth) =>
  declaredNetWealth == null || declaredNetWealth === "";
